import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import BackToTop from "./BackToTop";
import InstallPrompt from "./InstallPrompt";
import OfflineBanner from "./OfflineBanner";
import SiteMeta from "./SiteMeta";
import { Toaster } from "sonner";
import useGA from "@/hooks/useGA";

export default function Layout() {
  const location = useLocation();
  useGA();
  useEffect(() => { window.scrollTo(0, 0); }, [location.pathname]);
  return (
    <div className="min-h-screen flex flex-col bg-white dark:bg-[#08090a]">
      <SiteMeta />
      <Header />
      <OfflineBanner />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <BackToTop />
      <InstallPrompt />
      <Toaster position="bottom-right" richColors closeButton />
    </div>
  );
}
